const AchievementsSection = () => {
  const achievements = [
    { value: '20+', label: 'Years of Experience in the IT Industry' },
    { value: '30+', label: 'Satisfied Clients We Have Served' },
    { value: '80+', label: 'Recognitions Over Two Decades' },
    { value: '60+', label: 'Awards & Certifications of Our Work' },
  ];

  return (
    <section className="relative w-full bg-primary-500 overflow-hidden py-14 md:py-16">
      <div className="absolute inset-0 opacity-10 pointer-events-none">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle, oklch(var(--background-50)) 1px, transparent 1px)',
          backgroundSize: '28px 28px'
        }}></div>
      </div>

      <div className="relative section-padding">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-12">
            <div className="flex items-center justify-center gap-3 mb-4">
              <span className="inline-flex w-6 h-6 items-center justify-center bg-background-50 text-foreground-900 rounded-sm">
                <i className="ri-trophy-line text-xs"></i>
              </span>
              <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-background-50/70">
                04 / Track Record
              </span>
            </div>
            <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-background-50">
              What We Have Done
            </h2>
          </div>

          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-4">
            {achievements.map((achievement, index) => (
              <div key={index} className="text-center relative">
                <div className="text-4xl md:text-5xl lg:text-6xl font-bold text-background-50 font-display mb-3 tabular-nums">
                  {achievement.value}
                </div>
                <p className="text-background-50/80 text-sm max-w-[200px] mx-auto leading-relaxed">
                  {achievement.label}
                </p>
                {index < achievements.length - 1 && (
                  <div className="hidden lg:block absolute right-0 top-1/2 -translate-y-1/2 w-px h-16 bg-background-50/30"></div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AchievementsSection;